import { Component,inject, OnInit, } from '@angular/core';
import { RouterModule, ActivatedRoute, Router } from '@angular/router';
import { PlatformService } from '../platform-service';
import { SessionService } from './services/session.service';
import { GetActiveSessionResponseDto } from './dtos/get-active-session.response.dto';
import { ToastService } from '../../common/services/toast.service';
import { LessonsToolsMappingService } from '../deeplink/services/lessons-tools-mapping.service';
import { TargetLinkURICustomizationService } from '../deeplink/services/target-link-uri-customization.service';
import { LessonsService } from '../lessons/services/lessons.service';
import { MessageModule } from 'primeng/message';
import { ERROR_KEY, MessageType } from '../message/message';
import { LessonsDto } from '../lessons/dtos/lessons.dto';
import { LaunchToolDto } from './dtos/launch-tool.dto';


@Component({
  selector: 'app-launch-tool',
  standalone: true,
  imports: [RouterModule,MessageModule],
  templateUrl: './launch-tool.html',
  providers:[LessonsToolsMappingService,TargetLinkURICustomizationService,PlatformService,SessionService,LessonsService]
})
export class LaunchToolComponent implements OnInit {
  items: any[] = [];
  private route = inject(ActivatedRoute);
  private toastService = inject(ToastService)
  private lessonsToolsMappingService = inject(LessonsToolsMappingService);
  private targetLinkURICustomizationService = inject(TargetLinkURICustomizationService);
  private platformService = inject(PlatformService);
  private sessionService = inject(SessionService);
  private lessonsService = inject(LessonsService)
  private router = inject(Router);
  private userData!:GetActiveSessionResponseDto;
  courseCode: string ;
  sessionId: string ;
  constructor(){
    this.courseCode = this.route.snapshot.paramMap.get('courseCode') as string;
    this.sessionId = this.route.snapshot.paramMap.get('sessionId') as string;  
  }
  ngOnInit(){
       if (this.courseCode && this.sessionId) {
          this.getUserData(this.sessionId).then(userData=>{
            this.userData = userData;
            this.ifCourseCodeIsValidAndDeeplinkedThenInitiateCourseLaunch()   
            //this.initiateCourseLaunchWithoutDeeplinking(userData);
      }).catch(error=>{
           console.error(`ERROR ${error.message}`);
         });
      }
  }
  private async ifCourseCodeIsValidAndDeeplinkedThenInitiateCourseLaunch(){
      const courseCode = this.courseCode;
      const isCourseCodeValidAndDeeplinked = await this.isCourseCodeValidAndDeeplinked(courseCode);
      if(!isCourseCodeValidAndDeeplinked)
        this.router.navigate([`/message/${MessageType.ERROR}/${ERROR_KEY.EITHER_LESSON_NOT_VALID_OR_NOT_DEEPLINKED}`])
      else
        await this.initiateCourseLaunch();
  }
  private async getUserData(sessionId:string):Promise<GetActiveSessionResponseDto>{
        return await this.sessionService.getActiveSession(sessionId)
  }
  // private initiateCourseLaunchWithoutDeeplinking(userData:GetActiveSessionDto){
  //     this.platformService.initiateCourseLibraryLaunch(this.courseCode,userData)
  // }
  private async initiateCourseLaunch(){
    try{
      const courseCode = this.courseCode;
      const isLessonDeeplinked = await this.isCourseCodeValidAndDeeplinked(courseCode)
      if(!isLessonDeeplinked)
        this.router.navigate([`/message/${MessageType.ERROR}/${ERROR_KEY.EITHER_LESSON_NOT_VALID_OR_NOT_DEEPLINKED}`])
      const isLinkedWithMultipleCourses = await this.isLinkedWithMultipleCourses(courseCode);
        if(isLinkedWithMultipleCourses){
          this.router.navigate([`/show-linked-sub-courses/${courseCode}/${this.sessionId}`])
        }else{
          const contentItems = await this.lessonsToolsMappingService.getContentItemsForLesson(courseCode);
          if(contentItems && contentItems.length === 1){
            const targetLinkURI = await this.targetLinkURICustomizationService.getTargetLinkURIAsPerToolMappedTo(this.courseCode,contentItems[0]);
              const userInfo: LaunchToolDto = {
              "id": this.userData.id,
              "userId": this.userData.learner.id,
              courseCode,
              "firstName": this.userData.learner.firstName,
              "lastName": this.userData.learner.lastName,
              "email": this.userData.learner.email,
              "createdAt": new Date(),
              "refreshedAt": new Date(),
              "custom":contentItems[0].custom,
              targetLinkURI
            }
            const openInNewWindow = false;
            this.platformService.initiateCourseLaunch(courseCode,userInfo,openInNewWindow)
          }
        }
    }catch(e:any){
      this.toastService.show({
        severity:"error",
        summary:"Launch Error",
        detail:"There was a problem launching the course"
      })
      console.error(`${e.message}`);
    }
  }
  private async isLinkedWithMultipleCourses(courseCode:string):Promise<boolean>{
      const getLessonToolMappingResponseDto = await this.lessonsToolsMappingService.getCountOfContentItemsForLesson(courseCode);
      return getLessonToolMappingResponseDto.count > 1;
  }
  private async isCourseCodeValidAndDeeplinked(courseCode:string):Promise<boolean>{
      const lesson = await this.lessonsService.getLesson(courseCode) as LessonsDto;
      if(lesson && lesson !== undefined)
        return lesson.isLessonAlreadyDeeplinked
      else
        return false;
  }
}

